import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import { fetchVerificationStatuses } from '../../../store/landscapeAPI/verificationStatus/reducers/verification-status.slice';
import Spinner from '../../atoms/Spinner/Spinner';
import {
  fetchContributionById,
  updateContribution,
} from '../../../store/landscapeAPI/value/reducers/contribution.slice';
import { ValueResponseDto } from '../../../store/landscapeAPI/value/dto/response/value-response.dto';
import { useNavigate, useParams } from 'react-router-dom';
import { LandscapeIndicatorContributionEditTemplate } from '../../templates';
import { ValueUpdateRequestDto } from '../../../store/landscapeAPI/value/dto/request/value-update-request.dto';
import { DEFAULT_VERIFICATION_STATUS_ID } from '../../../utils/UUID';

interface LandscapeIndicatorContributionEditPageProps {}

const LandscapeIndicatorContributionEditPage: FC<
  LandscapeIndicatorContributionEditPageProps
> = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { id, landscapeIndicatorId, contributionId } = useParams();

  const [contribution, setContribution] = useState<ValueResponseDto>();

  const { verificationStatuses, status } = useSelector(
    (state: RootState) => state.verificationStatusSlice
  );

  useEffect(() => {
    dispatch(fetchContributionById(contributionId!))
      .unwrap()
      .then((resp) => setContribution(resp));
  }, [contributionId, dispatch]);

  useEffect(() => {
    dispatch(fetchVerificationStatuses());
  }, [dispatch]);

  const handleOnChange = (contribution: ValueResponseDto) => {
    setContribution(contribution);
  };

  const callbackFn = async (contribution: ValueResponseDto) => {
    const contributionToUpdate: ValueUpdateRequestDto = {
      indicatorId: '',
      qty: contribution.qty,
      qtyUnit: contribution.qtyUnit,
      time: contribution.time,
      timeUnit: contribution.timeUnit,
      compactId: id!,
      date: contribution.date,
      compactIndicatorId: landscapeIndicatorId!,
      verificationStatusId:
        contribution.verificationStatusId || DEFAULT_VERIFICATION_STATUS_ID,
      id: contribution.id,
      published: contribution.published,
    };
    await dispatch(updateContribution(contributionToUpdate));
    navigate(
      `/landscapes/edit/${id}/indicators/edit/${landscapeIndicatorId}/contribution`
    );
  };

  if (status === 'loading') {
    return <Spinner />;
  }

  return (
    <>
      {contribution && (
        <LandscapeIndicatorContributionEditTemplate
          verificationStatuses={verificationStatuses ?? []}
          contribution={contribution}
          handleOnChange={handleOnChange}
          callbackFn={callbackFn}
        />
      )}
    </>
  );
};

export default LandscapeIndicatorContributionEditPage;
